import { useLocation } from 'react-router';

export function getCorrectedHref(href: string | undefined) {
    if (!href) return '/';
    return href.startsWith('/') ? href : '/' + href;
}

/**
 * Custom hook to determine if the current location matches a given href.
 * Relies on the `useLocation` hook from React Router.
 *
 * @param href - The URL to check against the current location.
 * @returns An object with:
 *  - `startMatch`: True if the location pathname starts with the corrected href.
 *  - `exactMatch`: True if the location pathname matches the corrected href exactly.
 *  - `getCorrectedHref`: The utility function for correcting hrefs (optional for external use).
 */
export default function useActiveNavLink(href?: string) {
    const location = useLocation();
    const correctedHref = getCorrectedHref(href);

    return {
        startMatch: location.pathname.startsWith(correctedHref),
        exactMatch: location.pathname === correctedHref,
        getCorrectedHref,
    };
}
